import React from 'react'
import { Script } from 'gatsby'

export const wrapPageElement = ({ element }) => {
  return (
    <>
      {element}
      <Script src="//gc.zgo.at/count.js" async data-goatcounter="https://fom.goatcounter.com/count" />
    </>
  )
}